import { StyleSheet, Dimensions } from "react-native";
const isMobile = Dimensions.get("window").width < 768;
const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
  },

  containerSecundario: {
    marginTop: 40,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 20,
  },

  containerNecociacoes: {
    flexDirection: isMobile ? "column" : "row",
    width: "100%",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: isMobile ? "flex-start" : "space-around",
    gap: 16,
  },

  containerTerceiroColumn: {
    flexDirection: "column",
    gap: 20,
  },
  containerCardComprar: {
    paddingHorizontal: "1.5%",
    width: 300,
    marginTop: 20,
    marginLeft: 30,
    alignSelf: "left",
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 4,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },

  token_header: {
    alignItems: "center",
    justifyContent: "center",
    marginRight: 15,
  },
  token_header_image: {
    width: 65,
    height: 65,
    borderWidth: 3,
    borderColor: "#196059",
    borderRadius: 50,
  },

  card: {
    paddingHorizontal: "1.5%",
    width: 300,
    height: 450,
    marginLeft: 30,
    alignSelf: "left",
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 4,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  cardHeader: {
    marginTop: 20,
    alignItems: "left",
    gap: 10,
  },
  cardContent: {
    marginTop: 20,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  cardFooter: {
    marginTop: 20,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  hr: {
    height: 2,
    marginTop: 10,
    backgroundColor: "#077A97",
    opacity: 0.5,
  },

  cardTitle: {
    fontSize: 10,
    fontWeight: "300",
    textTransform: "uppercase",
    color: "#2C2C2E",
  },
  cardNameToken: {
    textAlign: "left",
    maxWidth: 200,
    fontSize: 16,
    fontWeight: "500",
    color: "#2C2C2E",
  },

  cardValue: {
    marginBottom: 8,
    maxWidth: 200,
    fontSize: 16,
    fontWeight: "500",
    color: "#2C2C2E",
  },

  cardValueGpx: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#000",
  },
  cardHeaderValue: {
    fontWeight: "bold",
    color: "#077A97",
    fontSize: 18,
  },
  /* FIM DO CARD */

  /* LINHA */
  hl: {
    height: 2,
    width: "90%",
    backgroundColor: "#2C2C2E",
    opacity: 0.5,
    paddingHorizontal: "10%",
  },
  /* FIM DA LINHA */

  /* INÍCIO CARD COMPRA */
  /* ordem limitada */
  priceInput: {
    width: 120,
    fontSize: 22,
    textAlign: "center",
    borderBottomWidth: 1,
    flex: 1,
    paddingVertical: 5,
    marginHorizontal: 10,
  },
  /* fim ordem limitada */
  /* início ordem rápida */
  switch: {
    flex: 1,
    backgroundColor: "#fff",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 15,
    marginTop: 24,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  /* fim ordem rápida */
  action_buttons_container: {
    marginTop: 20,
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  action_button: {
    padding: 10,
    borderWidth: 0.5,
    borderColor: "#077A97",
    borderRadius: 4,
    width: "60%",
  },

  btnCompra: {
    backgroundColor: "#077A97",
  },

  btnVenda: { width: "60%" },

  btnSemSaldo: {
    backgroundColor: "#889295",
    borderColor: "#889295",
  },

  actionButtonTxtComprar: {
    color: "#FFF",
    textTransform: "uppercase",
    fontWeight: "bold",
    textAlign: "center",
  },
  actionButtonVender: {
    textTransform: "uppercase",
    fontWeight: "bold",
    color: "#077A97",
    textAlign: "center",
  },
  /* FIM CARD COMPRA */

  /* ORDENS */
  titleOrdersAndTrade: {
    fontWeight: "bold",
    color: "#077A97",
    fontSize: 18,
    marginBottom: 6,
  },
  ContainerOrders: {
    maxWidth: 340,
    paddingHorizontal: 25,
    paddingVertical: 25,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  ordersTitle: {
    fontSize: 10,
    fontWeight: "300",
    textTransform: "uppercase",
    color: "#2C2C2E",
  },

  erroMinimo11: {
    color: "red",
    marginTop: 6,
  },

  /* FIM DAS ORDENS */

  /* INÍCIO DAS NEGOCIAÇÕES */
  containerTrades: {
    maxWidth: 340,
    paddingHorizontal: 25,
    paddingVertical: 25,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  /* FIM DAS NEGOCIAÇÕES */

  balance_info_container: {
    flexDirection: "row",
    paddingHorizontal: "10%",
    marginTop: 25,
    justifyContent: "space-between",
  },
  balance_info_title: {
    fontSize: 12,
    fontWeight: "bold",
  },

  contentPurchase: {
    paddingHorizontal: 25,
    marginTop: 20,
  },
  titlePurchase: {
    textAlign: "center",
    marginBottom: 20,
  },
  contentPurchaseAmount: {
    paddingHorizontal: 20,
    flexDirection: "row",
    justifyContent: "center",
  },
  contentOrders: {
    flexDirection: "row",
  },
  orderPurchases: {
    fontSize: 12,
  },
  orderPurchasesBold: {
    fontSize: 12,
    fontWeight: "bold",
  },
  orderSale: {
    fontSize: 12,
  },
  orderSaleBold: {
    fontSize: 12,
    fontWeight: "bold",
  },
  contentDescriptionOrders: {
    flexDirection: "row",
    gap: 55,
    paddingVertical: 5,
  },
  textDescriptionsOrders: {
    fontSize: 12,
    width: "40%",
  },
  actionsOrders: {
    fontSize: 12,
    width: "20%",
  },
  contentPurchaseOrSale: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  amountPurchase: {
    fontSize: 12,
  },
  pricePurchase: {
    fontSize: 12,
    color: "green",
  },
  amountSale: {
    fontSize: 12,
  },
  priceSale: {
    fontSize: 12,
    color: "#B90000",
  },
  contentInfoGraphic: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  titleInfoGraphic: {
    fontSize: 12,
    fontWeight: "bold",
    marginTop: 10,
  },
  infoGraphic: {
    color: "rgba(44, 44, 46, 0.5)",
    fontSize: 10,
    marginTop: 10,
  },
  dropdown: {
    // width: '85%',
    height: 30,
  },
  numberInput: {
    flex: 1,
    backgroundColor: "#f1f1f1",
    borderWidth: 1,
    borderColor: "#ccc",
  },

  textEnabled: {
    color: "#222",
  },
  textDisabled: {
    color: "#666",
  },

  percentageButtonsContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
    paddingHorizontal: 15,
  },
  percentageButton: {
    borderWidth: 1,
    flex: 1,
    margin: 10,
    padding: 10,
    borderRadius: 4,
  },
  percentageButtonText: {
    textAlign: "center",
  },
  emptyOrders: {
    fontSize: 13,
    textAlign: "center",
  },

  errorTxtSemSaldo: {
    color: "#",
    textTransform: "uppercase",
    fontWeight: "bold",
    textAlign: "center",
  },

  containerErro: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  containerGrafico: {
    marginRight: 50,
    gap: 20,
    flexDirection: "column",
    alignItems: "space-between",
  },
});

export default styles;
